/**
 * Normal
 * ------
 * 
 * June 2026
 */

import { InputNumber } from "primereact/inputnumber";

/**
 * Distribution component for editing the parameters of a normal distribution.
 * 
 * @param {String} elementType      - Type of element tied to distribution. (actions, resources, entity_types)
 * @param {Object} element          - Attributes for an element being edited.
 * @param {Object} attr             - Distribution parameters tied with element attribute.
 * @param {Function} distUpdater    - Sets which distribution is currently being used.
 * @param {Function} warningUpdater - Updates warnings for an element parameter.
 * @param {Object} configWarnings   - Verification warnings for model elements.
 */
function Normal({ elementType, element, attr, distUpdater, warningUpdater, configWarnings }) {
    const normalWarnings = {
        'mean': function(newMean) { return newMean < 0 ? `${attr} - mean must be positive.` : null},
        'std_deviation': function(newStdDev) { return newStdDev <= 0 ? `${attr} - standard deviation must be greater than 0.` : null}
    }

    /**
     * Updates the normal distribution's parameters for an attribute.
     * 
     * Example parameters:
     *  - mean
     *  - standard deviation
     * 
     * @param {String} normalParam  - Normal parameter being updated.
     * @param {Number} newValue     - Updated value for the normal parameter.
     */
    const handleNormal = (normalParam, newValue) => {
        const newNormal = {...element[attr].attr, [normalParam]: newValue};
        const newDist = {...element[attr], attr: newNormal};

        warningUpdater(element.gid, attr, normalWarnings['mean'](newNormal.mean) || normalWarnings['std_deviation'](newNormal.std_deviation));

        distUpdater(attr, newDist);
    }

    return (
        <div>
            <div style={{ marginBottom: '0.5rem' }}>
                <label style={{ marginRight: '0.5rem' }}>Mean:</label>
                <InputNumber value={element[attr].attr.mean} onValueChange={(event) => handleNormal('mean', event.target.value)} invalid={!!configWarnings[elementType]?.[element.gid]?.[attr]} inputStyle={{ width: '110px' }}/>
            </div>
            <div style={{ marginBottom: '0.5rem' }}>
                <label style={{ marginRight: '0.5rem' }}>Std. Deviation:</label>
                <InputNumber value={element[attr].attr.std_deviation} onValueChange={(event) => handleNormal('std_deviation', event.target.value)} invalid={!!configWarnings[elementType]?.[element.gid]?.[attr]} inputStyle={{ width: '110px' }}/>
            </div>
        </div>
    )
}

export default Normal;